<template>
  <div id="app" class="main">
    <div class="warp">
      <!--<div class="title">
        没有账号/
        <a href>立即注册</a>
      </div>-->
      <div class="register_box">
        <div class="register_title">修改密码</div>
        <div class="reg_warp">
          <div class="field">
            <input v-model="phone" type="input" placeholder="请输入手机号" />
          </div>
          <div class="field">
            <input type="input" class="code" v-model="code" placeholder="请输入验证码" />
            <button type="button" class="btn-code" :disabled='isDisabled'  ref="codeBtn" @click="sendSMS" >{{smsBtnText}}</button>
          </div>
          <div class="field">
            <input v-model="newPwd" type="password"  placeholder="请输入新密码" />
          </div>
          <div class="field">
            <input v-model="newPwd2"  type="password"  placeholder="请确认新密码" />
          </div>

          <!--
           <div class="field">
            <input type="input" class="code" placeholder="请输入验证码" />
            <input type="button" class="btn-code" value="获取验证码" />
          </div>
          -->
          <!--
          <div class="field">
            <input type="input" class="code" placeholder="请输入图形验证码" />
            <img class="yzm" src="/static/images/yzm.jpg" width="130" height="30" />
          </div>
          -->
      
          <div class="field">
            <input @click="submit" type="button" class="register" value="确认" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {editPwdApi,logoutApi,sendSMS} from  '@/service/allApi'
import {disableSmsButton} from  '../utils/util';
export default {
  data(){
    return {
  
        phone:"",
        code:"",
        newPwd:"",
        newPwd2:"",
        smsBtnText:"发送验证码",
        isDisabled:false,
      
    }
  },
  methods:{
    async submit(){
      let pass = true

      if(this.phone == "" && ( this.phone.length < 11 )){
        alert("请输入正确的手机格式")
        pass = false
      }
      if(pass && this.code.length == 0 ){
        alert("请输入验证码");
        pass = false
      }
      if(pass && this.newPwd.length == 0 ){
        alert("请输入新密码，并且长度不能小于6")
        pass = false
      }
      if(pass && ( this.newPwd != this.newPwd2 )){
        alert("输入的两次新密码不一至")
        pass = false
      }
      if(pass){ 
        const options = {
          phone:this.phone,
          oldPwd:this.oldPwd,
          newPwd:this.newPwd,
          newPwd2:this.newPwd2
        }

        const res = await editPwdApi(options)
        if(res.data.code == 100 ){
          alert("修改密码成功,请使用新密码登录")
          await logoutApi()
          localStorage.removeItem("user")
          this.$router.push("/login")
        }else{
          alert("修改密码失败")
        }
      }
    },
    async sendSMS(){
     
      let tel = this.phone
      if(this.checkMobile(tel)){
        const res = await sendSMS(tel,1);
        // console.log(res)
        if(res.data.code === 100){
          disableSmsButton(this.$refs.codeBtn,60)
        }else{
          alert("获取短信失败，请联系管理员");
        }

      }else{
        alert("手机格式错误");
      }
    },
    // 验证手机号
    checkMobile(str) {
      let re = /^1\d{10}$/
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
<style scoped>
button{
  cursor: pointer;
}
.main {
  background: url("/static/images/register_bg.png");
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;

  background-size: 100%;
}
.warp {
  position: absolute;
  width: 608px;
  height: 586px;
  left: 50%;
  top: 50%;
  margin-left: -304px;
  margin-top: -293px;
}
.title {
  text-align: right;
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 10px;
}
.title a {
  color: #ff3434;
  text-decoration: none;
}
.register_box {
  background-color: #ffffff;
  width: 608px;
  height: 517px;
  border-radius: 8px;
}
.register_title {
  border-bottom: 1px #e6e6e6 solid;
  text-align: center;
  font-size: 24px;
  line-height: 60px;
}
.field {
  width: 417px;
  margin: 0 auto;
  margin-top: 40px;
}
.field input {
  border: none;
  border-bottom: 1px #e6e6ee solid;
  width: 100%;
  line-height: 30px;
  font-size: 15px;
}
.field input.code {
  width: 240px;
}
.field input.btn-code {
  width: 130px;
  background-color: #5353ce;
  border-radius: 4px;
  color: #e6e6e6;
}
.field .register {
  margin-top: 40px;
  background-color: #5353ce;
  border-radius: 4px;
  color: #e6e6e6;
  line-height: 40px;
}
.field input.radio {
  width: 20px;
}
.field span {
  color: #666;
  font-size: 14px;
}
.field a {
  text-decoration: none;
  color: #5353ce;
  font-size: 14px;
}
.field button.btn-code {
  width: 130px;
  background-color: #5353ce;
  border-radius: 4px;
  color: #e6e6e6;
  border: none;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue